function toggleBorderRadius (e) {
    $(e.target).closest('.accordion-card').toggleClass('rounded-bottom-0')
}